import { render, staticRenderFns } from "./TileNotificationsOptions.vue?vue&type=template&id=42e4c480&scoped=true&"
import script from "./TileNotificationsOptions.vue?vue&type=script&lang=ts&"
export * from "./TileNotificationsOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e4c480",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
